import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { integrationApi, type ActivityEntry } from '../../api/integration';

export function ConnectorLogsPage() {
  const [activity, setActivity] = useState<ActivityEntry[]>([]);

  useEffect(() => {
    void integrationApi.listActivity(50).then(setActivity);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Connector Logs</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Integration activity, connector events and audit trail.</p>
      <Link to="/integrations" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← Integration Hub</Link>
      <div className="mt-6 overflow-x-auto rounded-xl border dark:border-slate-700">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 dark:bg-slate-800">
            <tr>
              <th className="px-4 py-2 text-left">Time</th>
              <th className="px-4 py-2 text-left">Category</th>
              <th className="px-4 py-2 text-left">Action</th>
              <th className="px-4 py-2 text-left">Message</th>
            </tr>
          </thead>
          <tbody>
            {activity.map((a) => (
              <tr key={a.id} className="border-t dark:border-slate-700">
                <td className="px-4 py-2 whitespace-nowrap text-xs text-slate-500">{new Date(a.created_at).toLocaleString()}</td>
                <td className="px-4 py-2">{a.category}</td>
                <td className="px-4 py-2">{a.action}</td>
                <td className="px-4 py-2">{a.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
